export default __webpack_public_path__ + "static/media/Kanto.4baae2db.jpg";